import React, {useState} from 'react';
import { useForm } from "react-hook-form";
import { Button,
    Grid,
    Select,
    TextField,
    InputLabel,
    FormControl,
    CardContent,
    Card,
    MenuItem
} from '@material-ui/core';
import Utils from '../../utils/utils';
import { yupResolver } from "@hookform/resolvers/yup";
import { getState } from "../../actions/dummy-actions";
import { styles } from  '../styles';
import _ from 'lodash';
import * as yup from "yup";

export const STATE = getState();
export default function SearchRegional({currentData, dataFilter, stateEdit, refresPaginator}) {

  const classes = styles();
  const [formSearch, setFormSearch] = useState({
    name: '',
    status: ''
  })

  const defaultValues = {
    status: '',
    name: '',
  };

  const schema = yup.object().shape({
    status: yup.string(),
    name: yup.string(),
  });

  const { register, handleSubmit } = useForm({
    resolver: yupResolver(schema),
    defaultValues
  });

  const onSubmit = data => {
    const info = {name: data?.name.normalize("NFD").replace(/[\u0300-\u036f]/g, '')}
    const newData = {...info, status: formSearch.status}

    const filterData = Utils.arrayFilter(currentData, newData);
    if(newData.status==='' && newData.name === ''){
      dataFilter(filterData)

    }
    else if(!newData.status && newData.name !== ''){
      const response=  Utils.arrayFilter(currentData, newData);
      dataFilter(response)
    }
    else if(!newData.name && newData.status !== '') {
      const response=  _.filter(filterData, {'status': newData.status})
      dataFilter(response)
    }else {
      const response =  _.filter(currentData, x => x?.name?.toLowerCase()?.includes(newData?.name?.toLowerCase())  && x?.status?.toLowerCase() === newData?.status?.toLowerCase());
      dataFilter(response);
    }
    refresPaginator();

  }

  const handleOnchange = (e) => {
    const {value, name} = e.target;
    setFormSearch({...formSearch, [name]: value})
  }

  const clearBtn = () => {setFormSearch(defaultValues);  dataFilter(currentData);}

  return (
    <div >
    <Card elevation = {0} style={{background: '#e0f2f7', marginLeft: -15}} >
    <CardContent>
    <form onSubmit={handleSubmit(onSubmit)} className={classes.form} autocomplete="off">
      <Grid container spacing={3} alignItems="center" justify="center">
          <Grid item xs={12} md={6} lg={4}>
            <FormControl fullWidth  notched={true}>
                <TextField
                    fullWidth
                    variant="outlined"
                    className = { classes.dropdownMultiple}
                    inputRef={register}
                    InputLabelProps = {{ shrink: true}}
                    type="text"
                    size = "small"
                    onChange={handleOnchange}
                    value={formSearch.name}
                    label="Regional"
                    name="name"
                />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6} lg={2}>
          <FormControl  variant="outlined" fullWidth  size="small" >
              <InputLabel htmlFor="outlined-select-estado" shrink={true} size="small" >Estado</InputLabel>
              <Select
                fullWidth
                size="small"
                inputRef={register}
                className = {classes.dropdown}
                label = "Estado"
                notched={true}
                name = "status"
                value = {formSearch.status}
                onChange={handleOnchange}
                inputProps = {
                    {
                        name: 'status',
                        id: 'outlined-select-estado',
                    }
                } >
                  <MenuItem
                      className={classes.menuItem}
                      key = "Activo"
                      value = "Activo"
                  >
                    Activo
                  </MenuItem>
                  <MenuItem
                      className={classes.menuItem}
                      key = "Inactivo"
                      value = "Inactivo"
                  >
                    Inactivo
                  </MenuItem>
              </Select>

            </FormControl>
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
          <Button
                variant="contained"
                className={classes.buttonSearch}
                type="submit"
              >
                Buscar
              </Button>
              &nbsp;&nbsp;
              <Button
                variant="contained"
                className={classes.buttonSearch}
                onClick={clearBtn}
              >
                Limpiar
              </Button>
          </Grid>
       </Grid>
      </form>
     </CardContent>
     </Card>
   </div>
  );

}
